export class BundleService {
  constructor($rootScope) {
    'ngInject';
    this.$rootScope = $rootScope;
  }

  getBundleType() {
    if (this.$rootScope.BUNDLE.type === undefined)
      this.$rootScope.BUNDLE.type = "roedl";
    return this.$rootScope.BUNDLE.type;
  }

}
